import script from "./ClientDetailPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDetailPanel.vue?vue&type=script&setup=true&lang=js"

import "./ClientDetailPanel.vue?vue&type=style&index=0&id=625dfe1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-625dfe1e"]])

export default __exports__